module.exports = __webpack_public_path__ + "static/media/finalPrize@2x.6b8f8937.png";